const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoCn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.716 40.458",
    style: {
      enableBackground: "new 0 0 212.716 40.458"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0F102C"
    },
    d: "M12.565,34.219C6.1,34.219,1,29.119,1,22.655c0-6.386,4.983-11.487,11.409-11.487 c5.528,0,10.318,3.583,11.447,9.073h-6.542c-0.934-2.025-2.609-3.038-4.827-3.038c-3.116,0-4.984,2.57-4.984,5.49 c0,3.037,1.985,5.489,5.139,5.489c2.141,0,3.699-1.012,4.672-2.881h6.58C22.648,30.599,18.015,34.219,12.565,34.219"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0F102C"
    },
    d: "M37.699,16.936c-2.335,0-4.397,1.363-4.904,3.698h9.808C42.097,18.299,40.034,16.936,37.699,16.936  M48.909,24.994H32.717c0.388,2.569,2.529,4.088,5.06,4.088c1.751,0,2.88-0.701,3.931-2.025h6.617 c-1.868,4.321-5.683,7.474-10.548,7.474c-6.305,0-11.443-5.138-11.443-11.443c0-6.267,4.982-11.599,11.326-11.599 c6.617,0,11.405,5.293,11.405,11.794C49.064,23.865,49.026,24.41,48.909,24.994"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0F102C"
    },
    d: "M85.415,34.569c-4.515,0-8.29-2.413-8.796-7.162h6.421c0.196,1.323,1.168,1.985,2.453,1.985 c0.973,0,2.257-0.545,2.257-1.674c0-1.558-1.752-2.024-2.919-2.491c-0.934-0.313-1.868-0.623-2.802-0.974 c-2.569-0.934-5.138-2.608-5.138-5.644c0-4.514,4.204-7.122,8.369-7.122c4.32,0,7.862,2.219,8.29,6.812h-6.344 c-0.039-1.206-0.895-1.635-2.024-1.635c-0.857,0-1.828,0.468-1.828,1.44c0,3.386,10.859,1.479,10.859,9.109 C94.212,32.078,89.813,34.569,85.415,34.569"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0F102C"
    },
    d: "M108.457,17.559c-2.997,0-5.176,2.53-5.176,5.449c0,2.92,2.179,5.451,5.176,5.451 c2.997,0,5.177-2.53,5.177-5.451C113.634,20.09,111.454,17.559,108.457,17.559 M108.457,34.491 c-6.616,0-11.638-4.865-11.638-11.483c0-6.616,5.022-11.481,11.638-11.481c6.617,0,11.638,4.865,11.638,11.481 C120.095,29.626,115.074,34.491,108.457,34.491"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0F102C"
    },
    d: "M174.659,16.936c-2.335,0-4.397,1.363-4.904,3.698h9.808 C179.058,18.299,176.995,16.936,174.659,16.936 M185.869,24.994h-16.192c0.389,2.569,2.53,4.088,5.061,4.088 c1.751,0,2.88-0.701,3.931-2.025h6.617c-1.868,4.321-5.683,7.474-10.548,7.474c-6.305,0-11.443-5.138-11.443-11.443 c0-6.267,4.982-11.599,11.326-11.599c6.617,0,11.405,5.293,11.405,11.794C186.025,23.865,185.986,24.41,185.869,24.994"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0F102C"
    },
    points: "197.74,12.227 197.74,9.966 197.74,5.152 191.279,7.332 191.279,12.145 191.279,12.227  188.092,13.3 188.086,17.131 191.279,17.131 191.279,33.829 197.74,33.829 197.74,17.131 200.854,17.131 200.854,12.227 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0F102C"
    },
    d: "M156.99,13.356c-1.402-1.167-3.698-1.868-5.527-1.868c-2.608,0-4.515,0.818-5.878,3.036h-0.076 v-2.233l-6.034,2.034v19.504h6.462V22.075c0-2.569,0.7-4.515,3.697-4.515c2.919,0,3.386,2.063,3.386,4.476v11.793h6.462V20.324 C159.482,17.793,159.053,15.068,156.99,13.356"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0F102C"
    },
    d: "M130.252,14.524h-0.077v-2.186l-6.072,2.048v19.443h6.461V21.958c0-3.347,2.257-3.892,5.099-3.971 v-6.499C133.171,11.488,131.381,12.305,130.252,14.524"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0F102C"
    },
    d: "M70.548,13.356c-1.402-1.167-3.698-1.868-5.527-1.868c-2.608,0-4.515,0.818-5.878,3.036h-0.076 v-2.233l-6.034,2.034v19.504h6.462V22.075c0-2.569,0.7-4.515,3.698-4.515c2.918,0,3.386,2.063,3.386,4.476v11.793h6.461V20.324 C73.04,17.793,72.612,15.068,70.548,13.356"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCF00"
    },
    d: "M208.476,32.001c-0.393,0.168-0.826,0.172-1.22,0.011c-0.395-0.16-0.703-0.464-0.871-0.858 c-0.166-0.391-0.171-0.824-0.011-1.219c0.158-0.394,0.462-0.704,0.855-0.871c0.204-0.087,0.415-0.127,0.621-0.127 c0.621,0,1.213,0.366,1.472,0.973C209.666,30.718,209.287,31.656,208.476,32.001 M211.079,29.162L211.079,29.162 c-0.758-1.781-2.822-2.612-4.598-1.857c-0.862,0.367-1.53,1.047-1.881,1.916c-0.35,0.869-0.341,1.821,0.026,2.681 c0.367,0.863,1.045,1.53,1.913,1.881c0.426,0.172,0.87,0.257,1.314,0.257c0.464,0,0.929-0.094,1.369-0.281 C211.003,33.003,211.835,30.94,211.079,29.162"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCn);
export default __webpack_public_path__ + "static/media/logo_cn.42525a2cedd7d5600a0ac96c117ad05b.svg";
export { ForwardRef as ReactComponent };